import React, { Fragment, useState, useEffect, useRef } from 'react';
import ChalanFormView from '../HelperChunks/ChalanFormView';
import LoginMenu from '../../../../components/LoginMenu/LoginMenu';
import CircularProgress from '@mui/material/CircularProgress';
import ReactToPrint from 'react-to-print';
import { Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

const TutionFeeChalanForm = () => {
    const [chalanData, setChalanData] = useState({});
    const [isLoginMenu, setIsLoginMenu] = useState(false);
    const [isReload, setIsReload] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const componentRef = useRef();

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setIsLoading(true);
        let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C13FinanceStudentsLegacyFeePendingVoucherView`;
        await fetch(url, {
            method: "GET",
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken"),
            }),
        })
            .then((res) => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                (json) => {
                    if (json.CODE === 1) {
                        if (json.DATA) {
                            if (json.DATA.length > 0) {
                                setChalanData(json.DATA[0] || {});
                            }
                        }
                    } else {
                        alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
                    }
                })
            .catch((error) => {
                if (error.status == 401) {
                    setIsLoginMenu(true);
                    setIsReload(true);
                } else {
                    alert('Operation Failed, Please try again later.');
                }
                console.log(error);
            });
        setIsLoading(false);
    }

    return (
        <Fragment>
            <ReactToPrint
                trigger={() => {
                    return <Button style={{
                        float: 'right',
                        marginTop: 10,
                        marginRight: 20,
                        textTransform: 'capitalize',
                        opacity: 0.8
                    }} color="primary" variant="contained">
                        <PrintIcon style={{ paddingRight: 5 }} /> Print
                    </Button>;
                }
                }
                content={() => componentRef.current}
                pageStyle="@page { size: landscape; margin: 0mm;}"
            />
            <LoginMenu reload={isReload} open={isLoginMenu} handleClose={() => setIsLoginMenu(false)} />
            {
                isLoading ? <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '20%',
                    alignItems: 'center'
                }}> <CircularProgress size={35} /> <span style={{ marginTop: 10 }}>Please Wait...</span> </div> :
                    <div ref={componentRef} style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        fontFamily: 'inherit',
                        marginTop: 50
                    }}>
                        <ChalanFormView data={chalanData} feeCard="School Copy" />
                        <ChalanFormView data={chalanData} feeCard="Bank Copy" />
                        <ChalanFormView data={chalanData} feeCard="Parent Copy" />
                    </div>
            }
        </Fragment >
    );
};

export default TutionFeeChalanForm;